'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { cleanupAppBadgeOnLogout } from '@module/mdrt-org/shared/utils/helpers/cleanup-app-badge-on-logout';
import { logOut } from '@shared/misc/next-auth/log-out';
import { Logout } from '@shared/ui-components/svgs';
import { loginHandler } from '../../utils/helpers/login-handler';
import { Button } from '../button/button';
import { useGlobalCmsContentContext } from '../providers/global-cms-context';
import styles from './authentication-button.module.scss';
export const AuthenticationButton = t0 => {
  const $ = _c(12);
  const {
    isAuthenticated,
    isMobile
  } = t0;
  const locale = useLocale();
  const {
    cmsContent
  } = useGlobalCmsContentContext();
  let t1;
  if ($[0] !== locale) {
    t1 = () => loginHandler({
      authorizationParameters: {
        ui_locales: locale
      }
    });
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cmsContent.loginLabel || $[3] !== t1) {
    t2 = {
      children: cmsContent.loginLabel,
      onClick: t1
    };
    $[2] = cmsContent.loginLabel;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const loginButtonProps = t2;
  let t3;
  if ($[5] !== cmsContent.logoutLabel) {
    t3 = {
      children: cmsContent.logoutLabel,
      onClick: _temp
    };
    $[5] = cmsContent.logoutLabel;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const logoutButtonProps = t3;
  let t4;
  if ($[7] !== isAuthenticated || $[8] !== isMobile || $[9] !== loginButtonProps || $[10] !== logoutButtonProps) {
    t4 = isMobile ? <Button className={styles["mobile-authentication-button"]} data-testid={isAuthenticated ? "log-out-button" : "log-in-button"} {...isAuthenticated ? logoutButtonProps : loginButtonProps} /> : isAuthenticated ? <button className={styles["authentication-button"]} data-testid="log-out-button" type="button" {...logoutButtonProps}><Logout className={styles["authentication-button__icon"]} />{logoutButtonProps.children}</button> : <button className={styles["authentication-button-login"]} data-testid="log-in-button" type="button" {...loginButtonProps} />;
    $[7] = isAuthenticated;
    $[8] = isMobile;
    $[9] = loginButtonProps;
    $[10] = logoutButtonProps;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
function _temp() {
  cleanupAppBadgeOnLogout();
  logOut();
  sessionStorage.removeItem("settingsPreviewModalWasDisplayed");
}